function setToken(tokenKey,token){
	return localStorage.setItem(tokenKey,token)
}
function getToken(tokenKey){
	return localStorage.getItem(tokenKey)
}
function removeToken(tokenKey){
	return localStorage.removeItem(tokenKey)
}
export default {setToken,getToken,removeToken}